import { render } from "./promos.vue?vue&type=template&id=d7b766f8&scoped=true"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"

import "./promos.vue?vue&type=style&index=0&id=d7b766f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b766f8"]])

export default __exports__